import { useMemo } from 'react';

import { TradeInPhone } from '../components/Phobio/types';

import useTmsApi from './useTmsApi';

const useGetTradeInPhones = (
  { minTradeInValue, shouldRunGet = true }:
  {minTradeInValue?: number, shouldRunGet?: boolean},
) => {
  const queryParams = minTradeInValue
    ? `?minTradeInValue=${minTradeInValue}`
    : '';
  const {
    response: tradeInResponse,
    loading,
    error,
  } = useTmsApi<TradeInPhone>(
    `/trade-in${queryParams}`,
    null,
    'get',
    'trade-in',
    shouldRunGet,
  );
  const response = useMemo(
    () => tradeInResponse
      ? tradeInResponse.response
        .map((phone) => ({
          contentful_id: phone.id,
          featuredPhoneFrontImage: {
            asset: {
              url: phone?.phoneImages?.small_image_full_url ?? '',
            },
            altText: phone.phoneName,
          },
          phoneVariants: [
            {
              phoneBrand: {
                displayName: phone.manufacturer,
              },
            },
          ],
          displayName: phone.phoneName,
          memory: phone.memory,
          tradeInValue: phone.tradeInValue,
        }))
        .sort((phone1, phone2) => phone1.displayName.localeCompare(phone2.displayName))
      : [],
    [tradeInResponse],
  );
  return { response, loading, error };
};

export default useGetTradeInPhones;
